<div class="add-guarantor-dialog container-fluid">
  <div class="row pt-4">
    <div class="col">
      <h3 class="subheading-2">Add guarantor</h3>
    </div>
  </div>

  <mat-dialog-content class="max-height-100-vh">
    <guarantor [formControl]="formControlGuarantors"
      [singleEntry]="true"
      [applicationId]="data.applicationId"
      [businessNumberSearchFn]="data.businessNumberSearchFn"
      [kybResultFn]="data.kybResultFn"
      [kybRefreshFn]="data.kybRefreshFn"
      [kybInitiateCorporatePartyFn]="data.kybInitiateCorporatePartyFn"
      (kybSelectionsChange)="kybSelections = $event"></guarantor>
  </mat-dialog-content>

  <div class="row py-3">
    <div class="col">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
        <button mat-flat-button color="primary" type="button" (click)="onDone()">Done</button>
      </div>
    </div>
  </div>
</div>
